import { Storage } from "@/utils/tools"
// import { getStorage, setStorage } from "@/utils/utils"
import { PiniaPluginContext } from "pinia"
import { toRaw } from "vue"

type Options = {
  key: string
  needKeepIds?: string[]
}
// 数据存储本地
const setStorage = (key: string, value: any) => {
  sessionStorage.setItem(key, JSON.stringify(value))
}
// 获取本地数据
const getStorage = (key: string) => {
  const data = sessionStorage.getItem(key)
  return data ? JSON.parse(data) : {};
}
const piniaPlugin = (options: Options) => {
  const { key, needKeepIds = [] } = options
  return (context: PiniaPluginContext) => {
    const { store } = context
    // console.log('PiniaPlugin',store.$id)
    const data = getStorage(`${key ?? "pinia"}-${store.$id}`)
    if (needKeepIds.length === 0) {
      store.$subscribe(() => {
        setStorage(`${key ?? "pinia"}-${store.$id}`, toRaw(store.$state))
      })
    } else {
      needKeepIds.includes(store.$id) &&
        store.$subscribe(() => {
          setStorage(`${key ?? "pinia"}-${store.$id}`, toRaw(store.$state))
        })
    }

    return {
      ...data,
    }
  }
}

export default piniaPlugin
